import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { ClipboardList, Tv, Megaphone, Trophy, MessageSquare, Sparkles, Loader2, Target, CalendarCheck } from "lucide-react";

// Quick links for club staff plus "Ask OCTON about my squad"
export function ClubCommand() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [a, setA] = useState("");
  const [busy, setBusy] = useState(false);
  const ask = async (question) => {
    const text = question || q;
    if (!text.trim()) return;
    setBusy(true); setA("");
    try { const { data } = await api.post("/api/club/ask", { question: text }); setA(data.answer); }
    catch (err) { toast.error(apiErr(err)); }
    setBusy(false);
  };
  const links = [
    ["Timetable", "/app/timetable", CalendarCheck, "#B57BFF"], ["Programming", "/app/programming", ClipboardList, "#CCFF00"], ["Gym TV", "/tv", Tv, "#3D7BFF"], ["News & challenges", "/app/community", Megaphone, "#FF5A5F"],
    ["Competitions", "/app/competitions", Trophy, "#FFD60A"], ["Messages", "/app/messages", MessageSquare, "#FF8A3D"], ["Habit plans", "/app/habits", Target, "#2DD4BF"],
  ];
  return (
    <div className="space-y-4" data-testid="club-command">
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3">
        {links.map(([l, to, I, c]) => (
          <button key={to} onClick={() => navigate(to)} className="group relative overflow-hidden rounded-xl border border-[#1E222A] bg-[#0F1115] p-4 text-left hover:border-white/20">
            <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full blur-2xl opacity-20 group-hover:opacity-40" style={{ background: c }} />
            <I className="relative w-5 h-5" style={{ color: c }} />
            <p className="relative text-sm font-semibold mt-2">{l}</p>
          </button>
        ))}
      </div>
      <div className="relative overflow-hidden rounded-2xl border border-acid/30 bg-gradient-to-br from-[#12160A] to-[#0B0D11] p-5">
        <p className="font-heading font-bold flex items-center gap-2"><Sparkles className="w-4 h-4 text-acid" /> Ask OCTON about your squad</p>
        <p className="text-xs text-[#8A91A6] mt-1">Answers come from training, attendance, scores and session feedback only. Never from athletes' chats, wellbeing or payments.</p>
        <div className="flex flex-wrap gap-2 mt-3">
          {["Who's dropping off and what should I do?", "Which sessions do athletes rate best?", "Who is ready to test a new 1RM?"].map((s) => (
            <button key={s} onClick={() => { setQ(s); ask(s); }} className="text-xs rounded-full border border-[#343A4A] px-3 h-7 text-[#B7BECB] hover:border-acid">{s}</button>
          ))}
        </div>
        <div className="flex gap-2 mt-3">
          <input className="flex-1 h-11 rounded-full bg-[#0B0D11] border border-[#1E222A] px-4 text-sm" placeholder="Ask anything about your athletes' training" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && ask()} data-testid="ask-input" />
          <button onClick={() => ask()} disabled={busy} className="h-11 px-5 rounded-full bg-acid text-black font-medium inline-flex items-center gap-2 disabled:opacity-60" data-testid="ask-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Ask"}</button>
        </div>
        {a && <p className="mt-4 text-sm text-[#D7DCE5] whitespace-pre-line rounded-xl border border-[#1E222A] bg-[#0B0D11] p-4" data-testid="ask-answer">{a}</p>}
      </div>
    </div>
  );
}
